import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getWorkSpace: (workSpaceId) => ({
        type: actionTypes.GET_WORK_SPACE,
        payload: {
            promise: () => api.getWorkSpace(workSpaceId)
        },
        scope: `${actionTypes.GET_WORK_SPACE}_${workSpaceId}`
    }),
    setTab: (tab) => ({
        type: actionTypes.SET_TAB,
        tab
    })
};
